import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import Button from '@mui/material/Button';
import { useColorScheme } from '@mui/material/styles';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export function ThemeSwitcher(): ReactElement {
    const { t } = useTranslation();
    const { mode, setMode } = useColorScheme();

    const isDark = mode === 'dark';

    return (
        <Button
            variant="outlined"
            color="primary"
            onClick={() => setMode(isDark ? 'light' : 'dark')}
            aria-label={t('HEADER.THEME_ARIA')}
            sx={{
                minWidth: 0,
                width: 36,
                height: 36,
                p: 0,
            }}>
            {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
        </Button>
    );
}
